import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { StoreContext } from "../../store/StoreContext";
import { sigIn } from "../../api/access";
import { requestToken } from "../../mongo-db/auth";
import { LOCAL_TOKEN } from "../../constants/local-entity";

const ReauthModal = ({ show, onClose }) => {
  const { session } = useContext(StoreContext);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPass, setIsPass] = useState(true);

  useEffect(() => {
    if (show) {
      setPassword("");
      setError("");
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return setError("Ingresa tu contrasena");

    setLoading(true);
    setError("");

    try {
      // Re-validar credenciales con Azure
      await sigIn(session.username, password);

      // Obtener nuevo JWT
      const tokenData = await requestToken(session.username);
      localStorage.setItem(LOCAL_TOKEN, tokenData.token);

      onClose(true); // true = reauth exitoso
    } catch (_) {
      setError("Contrasena incorrecta. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    onClose(false); // false = usuario decidio no reautenticarse
  };

  return (
    <Modal show={show} onHide={handleSkip} centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faShieldAlt} className="text-warning" />
          Sesion expirada
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Tu sesion de seguridad ha expirado. Ingresa tu contrasena para continuar
          trabajando sin perder tus datos.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-bold">{session?.username}</label>
          </div>
          <div className="mb-3">
            <label htmlFor="reauth-password" className="form-label">
              Contrasena
            </label>
            <div className="input-group">
              <input
                type={isPass ? "password" : "text"}
                className={`form-control ${error ? "is-invalid" : ""}`}
                id="reauth-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                autoFocus
              />
              <span
                className="input-group-text cursor-pointer"
                onClick={() => setIsPass((prev) => !prev)}
              >
                {isPass ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>
            {error && <div className="text-danger mt-1 small">{error}</div>}
          </div>
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleSkip}
              disabled={loading}
            >
              Continuar sin conexion
            </button>
            <button
              type="submit"
              className="btn bg-primary text-white px-4"
              disabled={loading}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm me-2" />
              ) : null}
              Verificar
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ReauthModal;
